<div class="root">
  <div class="avatar">
    <vim-core-user-avatar
      [user]="message.author"
      [avatarUrl]="message.author.avatarUrl"
      [size]="40"
      [backgroundColor]="message.author.avatarUrl ? 'transparent' : undefined"
      [dsTooltip]="message.author.hint ?? ''"
      dsTooltipPosition="bottom"
    ></vim-core-user-avatar>
  </div>
  <div class="content">
    <div class="message-info">
      <div class="author-name" data-test="автор">{{ message.author.name }}</div>
      <div class="message-time" data-test="дата">
        {{ formatTime(message) }}
      </div>
    </div>
    <div>
      <quill-view-html
        class="message-body"
        [content]="message.body"
        [sanitize]="true"
      ></quill-view-html>
      <div class="attachment-grid">
        @for (attachment of message.attachments; track trackByAttachment($index, attachment)) {
          <skypro-message-attachment-preview
            class="attachment-item"
            [class.-big]="bigAttachmentPreview"
            [bigAttachmentPreview]="bigAttachmentPreview"
            [url]="attachment.url"
            [title]="attachment.title"
          ></skypro-message-attachment-preview>
        }
      </div>
    </div>
    <ng-content select="[messageActions]"></ng-content>
  </div>
</div>
